import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-help-fast-input-dialog',
  templateUrl: 'help-fast-input-dialog.component.html',
  styleUrls: ['./help-fast-input-dialog.component.scss'],
  standalone: false,
})
export class HelpFastInputDialogComponent {
  constructor(public dialogRef: MatDialogRef<HelpFastInputDialogComponent>) {}

  cancel(): void {
    this.dialogRef.close();
  }
}
